import ViewClientForm from '@/components/clients/ViewClientForm';
import Loader from '@/components/ui/Loader';
import { useGetClient } from '@/hooks/useAgencyClient';
import { useParams } from 'react-router';

const ViewClientPage = () => {
  const { clientId } = useParams();

  const {
    data: clientResponse,
    isLoading,
    isSuccess,
  } = useGetClient(clientId ?? '');

  return isLoading ? (
    <Loader />
  ) : (
    isSuccess && (
      <ViewClientForm
        key={`client-${clientResponse.client.id}`}
        clientResponse={clientResponse.client}
        countProjects={clientResponse.countProjects}
      />
    )
  );
};

export default ViewClientPage;
